var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticStyle:{"padding":"20px","text-align":"center"}},[_vm._v(" Oops, it looks like the page you're looking for doesn't exist. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }